import request from '@/utils/request'
import util from '@/utils/util'

export function webSetting() {
  const CACHE_KEY = 'cache:webSetting';
  const CACHE_TIMER_KEY = 'cache:webSetting:timer';
  const CACHE_DURATION = 60 * 60 * 24 * 7 * 1000; // 7天（毫秒）

  const expiry = window.localStorage.getItem(CACHE_TIMER_KEY);
  const cached = util.getLocalstorage(CACHE_KEY);
  if (expiry && cached && parseInt(expiry) > new Date().getTime()) {
    try {
      return Promise.resolve(JSON.parse(cached));
    } catch (e) {
      // 缓存解析失败，继续发起请求
    }
  }

  return request({
    url: '/WebSetting?v=' + util.getVersion(),
    method: 'get'
  }).then((res) => {
    window.localStorage.setItem(CACHE_TIMER_KEY, new Date().getTime() + CACHE_DURATION);
    util.setLocalstorage(CACHE_KEY, res);
    return res;
  });
}

export function currentUser() {
  return request({
    //url: '/connect/userinfo',
    url: '/BaseUser/Current',
    method: 'get',
    cache: 60 * 60
  }).then((res) => {
    return res.data;
  });;
}

export function currentMenus(category) {
  return request({
    url: '/BaseModule/UserTreeData?category=' + (category || '') + '&v=' + util.getVersion(),
    params: {},
    method: 'get',
    cache: 60 * 60
  }).then((res) => {
    return res.data;
  });
}



export function fetchUsers(params) {
  return request({
    url: '/BaseUser/' + (params.method || 'Search'),
    method: 'post',
    data: params
  });
}


export function delUsers(id) {
  return request({
    url: '/BaseUser/' + id,
    method: 'delete'
  });
}


export async function submitUser(data) {
  const submitData = { ...data };
  if (submitData.password) {
    submitData.password = await util.encryptPassword(submitData.password, 'sha256');
  }
  return request({
    url: '/BaseUser/' + (submitData.id || ''),
    method: submitData.id ? 'put' : 'post',
    data: submitData
  });
}



/**
 * 重置主密码（迁移期兼容实现）
 *
 * 当前：legacy 明文优先，失败后回退到 sha256 前缀格式重试。
 * 目标：全量升级完成后改为 sha256-only（移除 legacy 首次请求）。
 * 迁移文档：docs/security/password-migration.md
 */
export async function resetUserPwd(data) {
  const rawOldPassword = data?.oldpassword;
  const rawNewPassword = data?.newpassword;
  if (!rawOldPassword || !rawNewPassword) {
    throw new Error('请填写旧密码和新密码');
  }

  // 第一阶段：保持与现网一致，优先透传明文给后端校验。
  const legacyParams = { ...data };
  [legacyParams.oldpassword, legacyParams.newpassword] = await Promise.all([
    util.encryptPassword(rawOldPassword, 'legacy'),
    util.encryptPassword(rawNewPassword, 'legacy')
  ]);

  try {
    return await request({
      url: '/BaseUser/reset',
      method: 'get',
      params: legacyParams
    });
  } catch (err) {
    const errText = [err?.error, err?.error_description, err?.content, err?.message]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    const shouldRetryWithSha256 = errText.includes('invalid_grant') || errText.includes('password') || errText.includes('密码');

    // 第二阶段：兼容已升级为 sha256 前缀格式的用户。
    if (shouldRetryWithSha256) {
      const sha256Params = { ...data };
      [sha256Params.oldpassword, sha256Params.newpassword] = await Promise.all([
        util.encryptPassword(rawOldPassword, 'sha256'),
        util.encryptPassword(rawNewPassword, 'sha256')
      ]);
      return request({
        url: '/BaseUser/reset',
        method: 'get',
        params: sha256Params
      });
    }

    return Promise.reject(err);
  }
}




export function fetchRoles(params) {
  return request({
    url: '/BaseRole/Search',
    method: 'post',
    data: params
  });
}


export function delRoles(id) {
  return request({
    url: '/BaseRole/' + id,
    method: 'delete'
  });
}


export function submitRole(data) {
  return request({
    url: '/BaseRole/' + (data.id || ''),
    method: data.id ? 'put' : 'post',
    data: data
  });
}

export function submitRelationByGlobalId(arr, category, globalId) {
  return request({
    url: '/BaseRelation/submitRelationByGlobalId/' + (category || '') + '/' + globalId,
    method: 'post',
    data: arr
  });
}


export function submitRelationByObjectId(arr, category, objectID) {
  return request({
    url: '/BaseRelation/submitRelationByObjectId/' + (category || '') + '/' + objectID,
    method: 'post',
    data: arr
  });
}


export function fetchRelationByGlobalId(category, globalId) {
  return request({
    url: '/BaseRelation/GetObjectKeys/' + (category || '') + '/' + globalId,
    method: 'get'
  });
}
export function fetchRelationByObjectId(category, objectId) {
  return request({
    url: '/BaseRelation/GetGlobalKeys/' + (category || '') + '/' + objectId,
    method: 'get'
  });
}

export function submitUserDataRange(objects, GlobalID) {
  return request({
    url: '/BasePermission/DataRange',
    method: 'post',
    params: {
      Category: 'Company',
      GlobalID
    },
    data: objects
  });
}

export function fetchUserDataRange(GlobalID) {
  return request({
    url: '/BasePermission/DataRange',
    method: 'get',
    params: {
      GlobalID
    }
  });
}


export function fetchApiLogs(params) {
  return request({
    url: '/SysApiLog/Search',
    method: 'post',
    data: params
  });
}
